import React from "react";
import { motion } from "framer-motion";
import { Users, Target, Heart, Award } from "lucide-react";
import styles from "./AboutPage.module.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

import Pizza  from "../assets/food.mp4";

export default function AboutPage() {
  const team = [
    {
      name: "Sarah Johnson",
      role: "Founder & Head Chef",
      image: "https://images.stockcake.com/public/e/c/9/ec99397d-f907-4b71-b645-479318f7c71e_large/chef-serving-food-stockcake.jpg",
    },
    {
      name: "Michael Chen",
      role: "Recipe Developer",
      image: "https://images.stockcake.com/public/7/c/8/7c81a6f1-5bab-4859-9c2a-6dc1541f8405_large/chef-cooking-intensely-stockcake.jpg",
    },
    {
      name: "Emma Williams",
      role: "Community Manager",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJzwM6p8a_5baYeb8uU3Ye5tnQ71aRwBt-cg&s",
    },
    {
      name: "James Garcia",
      role: "Food Photographer",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSB7OaHtzgAiW26Ox2Eh-K2KWIDwH9-ShQLQQ&s",
    },
  ];

  const values = [
    {
      icon: Heart,
      title: "Passion for Food",
      description:
        "We believe cooking is an art form that brings people together.",
    },
    {
      icon: Users,
      title: "Community First",
      description:
        "Built on the collective knowledge of home chefs worldwide.",
    },
    {
      icon: Target,
      title: "Quality Content",
      description:
        "Every recipe is tested to ensure the best experience.",
    },
    {
      icon: Award,
      title: "Excellence",
      description:
        "We strive for excellence in everything we do.",
    },
  ];

  return (

    <div>
    <Header />
     <section className={styles.hero}>
  {/* Background Video */}
  <video
    className={styles.videoBg}
    src={Pizza}   
    autoPlay
    loop
    muted
    playsInline
  />

  {/* Dark Overlay */}
  <div className={styles.videoOverlay}></div>

  {/* Content */}
  <div className={styles.heroContent}>
    <h1>About <span>UVFOOD BOX</span></h1>
    <p>Connecting food lovers worldwide</p>
  </div>
</section>

      {/* Values Section */}
      <section className={styles.valuesSection}>
        <h2>Our Values</h2>
        <div className={styles.valuesGrid}>
          {values.map((value, index) => (
            <motion.div
              key={index}
              className={styles.card}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
            >
              <value.icon className={styles.icon} />
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section className={styles.teamSection}>
        <h2>Meet Our Team</h2>
        <div className={styles.teamGrid}>
          {team.map((member, index) => (
            <motion.div
              key={index}
              className={styles.teamCard}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
            >
              <img src={member.image} alt={member.name} />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </motion.div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}